// Figma: 5701:21782 — see stories/blocks/about-hero-cta.stories.tsx
"use client";

import * as React from "react";

import { ArrowCtaButton } from "@/components/ui/arrow-cta-button";
import { Link } from "@/components/ui/link/link";
import {
  isPlainLeftClick,
  smoothScrollToHash,
} from "@/lib/smooth-scroll-to-hash";

export function AboutHeroCta({
  href,
  label,
  external,
}: {
  href: string;
  label: string;
  external?: boolean;
}) {
  const isHashLink = href.startsWith("#");

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isHashLink || !isPlainLeftClick(event)) return;

    event.preventDefault();
    smoothScrollToHash(href);
  };

  return (
    <ArrowCtaButton
      render={
        <Link
          href={href}
          external={external}
          onClick={isHashLink ? handleClick : undefined}
        />
      }
      className="text-ds-body-sm"
    >
      {label}
    </ArrowCtaButton>
  );
}
